import { Component, Output, EventEmitter, Input } from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { navItems } from '../../vertical/sidebar/sidebar-data';
import { TranslateService } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { BrandingComponent } from '../../vertical/sidebar/branding.component';
import { AppSettings } from 'src/app/config';
import { FormsModule } from '@angular/forms';
import { AuthService } from 'src/app/core/services/auth.service';
import { ApscanLoginDialogComponent } from '../../vertical/header/apscan-login-dialog.component';
import { RegistreService } from 'src/app/core/services/registre.service';
import { PopupAndNotifService } from 'src/app/core/services/popup-and-notif.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { InappNotificationBellComponent } from 'src/app/core/components/inapp-notification-bell/inapp-notification-bell.component';
import { InappNotificationsService } from 'src/app/core/services/inapp-notifications.service';
import { AppVersionComponent } from '../../shared/app-version/app-version.component';

interface profiledd {
  id: number;
  title: string;
  link: string;
  new?: boolean;
}

interface apps {
  id: number;
  icon: string;
  color: string;
  title: string;
  subtitle: string;
  link: string;
}

@Component({
  selector: 'app-horizontal-header',
  imports: [
    RouterModule,
    TablerIconsModule,
    MaterialModule,
    BrandingComponent,
    InappNotificationBellComponent,
    AppVersionComponent,
  ],
  templateUrl: './header.component.html',
})
export class AppHorizontalHeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  @Output() optionsChange = new EventEmitter<AppSettings>();

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: '/assets/images/flag/icon-flag-en.svg',
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Español',
      code: 'es',
      icon: '/assets/images/flag/icon-flag-es.svg',
    },
    {
      language: 'Français',
      code: 'fr',
      icon: '/assets/images/flag/icon-flag-fr.svg',
    },
    {
      language: 'German',
      code: 'de',
      icon: '/assets/images/flag/icon-flag-de.svg',
    },
  ];

  currentUser: any;
  currentUserSignal = this.authService.currentUser();
  group: string[] = [];

  constructor(
    private settings: CoreService,
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    public authService: AuthService,
    private registreservice: RegistreService,
    private popupAndNotifService: PopupAndNotifService,
    private helperService: HelperService,
    private inappNotificationsService: InappNotificationsService
  ) {
    translate.setDefaultLang('en');
    this.currentUser = this.authService.currentUser();
    if (this.currentUser?.group) {
      this.group = this.currentUser.group;
    }
    if (this.authService.isLogged()) {
      this.inappNotificationsService.startRealtimeStream();
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(AppHorizontalSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }

  options = this.settings.getOptions();

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }

  setlightDark(theme: string) {
    this.options.theme = theme;
    this.emitOptions();
  }

  connect_to_apscan() {
    const dialogRef = this.dialog.open(ApscanLoginDialogComponent, {
      width: '400px',
      data: {
        currentUser: this.currentUser,
      },
    });

    dialogRef.afterClosed().subscribe((connected) => {
      if (connected) {
        this.authService.is_aptokenaccess = true;
      }
    });
  }

  logout_to_apscan() {
    this.popupAndNotifService
      .confirmAction('Confirmation', 'Are you sure you want to logout?', 'Confirm', 'Cancel')
      .subscribe((result) => {
        if (result) {
          this.authService.is_aptokenaccess = false;
          this.popupAndNotifService.showSpinner();
          this.registreservice.apsolution_logout(this.currentUser.username).subscribe((data) => {
            this.popupAndNotifService.hideSpinner();
            if (data['status'] == 'success') {
              this.helperService.openSnackBar('You are disconnected from APSCAN', 'Close');
            } else {
              this.helperService.openSnackBar(data['message'], 'Close');
            }
          });
        }
      });
  }

  canAccessKycHeaderTools(): boolean {
    return (
      this.group?.includes('superadmin') ||
      this.group?.includes('kyc_bo') ||
      this.group?.includes('ext_kyc_bo') ||
      this.group?.includes('kyc_validator')
    );
  }

  canAccessSuperAdminProductLaunchers(): boolean {
    return this.authService.isSuperAdmin();
  }

  openDataroomAdmin(): void {
    if (typeof window === 'undefined') {
      return;
    }
    // Lands on the GED view for every user (Datarooms stays one click away).
    const route = '/dataroom/admin/ged';
    const isLocal =
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1';
    if (isLocal) {
      window.location.assign(`http://localhost:8184${route}`);
      return;
    }
    const { origin, search, hash } = window.location;
    window.location.assign(`${origin}${route}${search}${hash}`);
  }

  profiledd: profiledd[] = [
    {
      id: 1,
      title: 'My Profile',
      link: '/',
    },
    {
      id: 2,
      title: 'My Subscription',
      link: '/',
    },
    {
      id: 3,
      title: 'My Invoice',
      new: true,
      link: '/',
    },
    {
      id: 4,
      title: ' Account Settings',
      link: '/',
    },
    {
      id: 5,
      title: 'Sign Out',
      link: '/authentication/login',
    },
  ];

  apps: apps[] = [
    {
      id: 1,
      icon: 'solar:chat-line-line-duotone',
      color: 'primary',
      title: 'Chat Application',
      subtitle: 'Messages & Emails',
      link: '/',
    },
    {
      id: 2,
      icon: 'solar:checklist-minimalistic-line-duotone',
      color: 'secondary',
      title: 'Todo App',
      subtitle: 'Completed task',
      link: '/',
    },
    {
      id: 3,
      icon: 'solar:bill-list-line-duotone',
      color: 'success',
      title: 'Invoice App',
      subtitle: 'Get latest invoice',
      link: '/',
    },
    {
      id: 4,
      icon: 'solar:calendar-line-duotone',
      color: 'error',
      title: 'Calendar App',
      subtitle: 'Get Dates',
      link: '/',
    },
    {
      id: 5,
      icon: 'solar:smartphone-2-line-duotone',
      color: 'warning',
      title: 'Contact Application',
      subtitle: '2 Unsaved Contacts',
      link: '/',
    },
    {
      id: 6,
      icon: 'solar:ticket-line-duotone',
      color: 'primary',
      title: 'Tickets App',
      subtitle: 'Create new ticket',
      link: '/',
    },
    {
      id: 7,
      icon: 'solar:letter-line-duotone',
      color: 'secondary',
      title: 'Email App',
      subtitle: 'Get new emails',
      link: '/',
    },
    {
      id: 8,
      icon: 'solar:book-2-line-duotone',
      color: 'warning',
      title: 'Contact List',
      subtitle: 'Create new contact',
      link: '/',
    },
  ];
}

@Component({
  selector: 'app-search-dialog',
  imports: [RouterModule, MaterialModule, TablerIconsModule, FormsModule],
  templateUrl: 'search-dialog.component.html',
})
export class AppHorizontalSearchDialogComponent {
  searchText: string = '';
  navItems = navItems;

  navItemsData = navItems.filter((navitem) => navitem.displayName);

  // filtered = this.navItemsData.find((obj) => {
  //   return obj.displayName == this.searchinput;
  // });
}
